import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth, useIsPlatformAdmin } from '../../../hooks/useAuth'
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs'
import { AgentPoolPage } from '../../../components/admin/AgentPoolPage'

export const Route = createFileRoute('/admin/agent-pool/')({
  component: RouteComponent,
})

// Gated with useIsPlatformAdmin like /admin/settings: an org-less, server-wide
// surface (spec 2026-10-21-19 §7).
function RouteComponent() {
  const { t } = useTranslation('admin')
  const { loading, orgCode } = useAuth()
  const isPlatformAdmin = useIsPlatformAdmin()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && !isPlatformAdmin) {
      navigate({ to: '/', replace: true })
    }
  }, [loading, isPlatformAdmin, navigate])

  const breadcrumbOrg = orgCode || 'demo'
  useBreadcrumbs([
    { title: t('common:nav.home'), path: `/${breadcrumbOrg}` },
    { title: t('settings:page.title'), path: `/${breadcrumbOrg}/settings` },
    { title: t('agent_pool.title') },
  ])

  if (loading || !isPlatformAdmin) {
    return null
  }

  return <AgentPoolPage org={breadcrumbOrg} />
}
